import { createAxiosThunk } from 'utils/reduxUtil'
import { isNullOrUndefinedOrEmpty, separateUrlProtocol } from 'utils'
import api from 'api/axios/foka'
import { BizChannelTypes } from '../../../Codes'

export const generateChannel = ({
  bizChannelType,
  unifiedUrl,
  pcUrl,
  mobileUrl,
  name,
  isUrlIndividual,
  hasAccessAccount,
  accessAccountId,
  accessAccountPassword,
  reviewDocuments,
  selectedCategoryDetail,
  kakaoTalkChannels,
}) => {
  const [unifiedAddrProtocol, unifiedAddrUrn] = separateUrlProtocol(unifiedUrl)
  const [pcAddrProtocol, pcAddrUrn] = separateUrlProtocol(pcUrl)
  const [mobileAddrProtocol, mobileAddrUrn] = separateUrlProtocol(mobileUrl)
  const bizChannelCateId = selectedCategoryDetail.id
  const documents = reviewDocuments.flatMap(
    ({ id, reviewDocumentType, files }) =>
      files.map(({ path, filename }) => ({
        type: reviewDocumentType,
        reviewRequiredDocumentId: id,
        path,
        filename,
      }))
  )
  const selectedKakaoTalkChannels = kakaoTalkChannels.filter(
    ({ isSelected }) => isSelected
  )
  return bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
    ? {
        name,
        individualSetting: isUrlIndividual,
        hasPcSite: !isNullOrUndefinedOrEmpty(
          isUrlIndividual ? pcUrl : unifiedUrl
        ),
        hasMobileSite: isUrlIndividual && !isNullOrUndefinedOrEmpty(mobileUrl),
        ...(isUrlIndividual
          ? {
              pcUrlProtocol: isNullOrUndefinedOrEmpty(pcAddrProtocol)
                ? null
                : pcAddrProtocol.toUpperCase(),
              pcUrl: isNullOrUndefinedOrEmpty(pcAddrUrn) ? null : pcAddrUrn,
              mobileUrlProtocol: isNullOrUndefinedOrEmpty(mobileAddrProtocol)
                ? null
                : mobileAddrProtocol.toUpperCase(),
              mobileUrl: isNullOrUndefinedOrEmpty(mobileAddrUrn)
                ? null
                : mobileAddrUrn,
            }
          : {
              pcUrlProtocol: unifiedAddrProtocol?.toUpperCase() || null,
              pcUrl: unifiedAddrUrn,
            }),
        hasAccessAccount,
        accessAccountId,
        accessAccountPassword,
        reviewDocuments: documents,
        bizChannelCateId,
        kakaoTalkChannels: selectedKakaoTalkChannels,
      }
    : {
        name,
        mobileUrlProtocol: mobileAddrProtocol?.toUpperCase() || null,
        mobileUrl: mobileAddrUrn,
        hasAccessAccount,
        accessAccountId,
        accessAccountPassword,
        bizChannelCateId,
        kakaoTalkChannel: selectedKakaoTalkChannels[0],
        reviewDocuments: documents,
      }
}

const addChannel = createAxiosThunk(
  'channelAdd/addChannel',
  (noArgs, { getState }) => {
    const {
      bizChannelType,
      unifiedUrl,
      pcUrl,
      mobileUrl,
      name,
      isUrlIndividual,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      reviewDocuments,
      selectedCategoryDetail,
      kakaoTalkChannels,
    } = getState().channel.channelAdd
    const channel = generateChannel({
      bizChannelType,
      unifiedUrl,
      pcUrl,
      mobileUrl,
      name,
      isUrlIndividual,
      hasAccessAccount,
      accessAccountId,
      accessAccountPassword,
      reviewDocuments,
      selectedCategoryDetail,
      kakaoTalkChannels,
    })
    return bizChannelType === BizChannelTypes.WEBSITE_BIZ_CHANNEL
      ? api.channel.addWebsiteChannel(channel)
      : api.channel.addTalkChannel(channel)
  }
)

addChannel.reducers = builder => {
  builder.addCase(addChannel.pending, state => {
    state.apiError = null
    state.isLoading = true
  })

  builder.addCase(addChannel.fulfilled, state => {
    state.isLoading = false
  })

  builder.addCase(addChannel.rejected, (state, { payload }) => {
    state.apiError = payload
    state.isLoading = false
  })
}

export default addChannel
